import { render, staticRenderFns } from "./boton_descarga_cotizacion.vue?vue&type=template&id=15d3ccbc&"
import script from "./boton_descarga_cotizacion.vue?vue&type=script&lang=js&"
export * from "./boton_descarga_cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports